import React, { useState, useContext, lazy, Suspense } from "react";
import FilteringControls from "./FilteringControls";
import ActionsContext from "common/ActionsContext";
import { Header } from "common/Header";
import MetricsHelpModal from "./Help";
import styled from "styled-components";

const Wrapper = styled.div`
  .card.attached {
    margin-top: -34px;
    padding-top: 10px;
  }
  .title-border {
    background: var(--card-header-border-color) !important;
    margin-top: -34px;
    margin-bottom: 34px;
    position: relative;
    z-index: 200;
    height: 1px;
  }
`;

const Report = lazy(() => import("./Report"));

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => actions.send("open-help")}
        >
          <i className="material-icons">help_outline</i>
        </a>
      </li>
      <li>
        <a
          onClick={() => actions.send("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
    </ul>
  );
};

export const applyParams = (child, params = {}) =>
  React.isValidElement(child) ? React.cloneElement(child, params) : child;

const _defaultSettings = {
  lines: 100000,
  direction: "downlink",
  policy: "all",
  subnet: "",
  colorizeQuartiles: false,
  subscriberGroup: "all",
};

const Subscribers = ({
  subnet,
  policy,
  returnView,
  subscriberGroup,
  timePeriod,
  metric,
  direction,
}) => {
  const defaults = {
    ..._defaultSettings,
    ...(subnet === undefined ? {} : { subnet }),
    ...(policy === undefined ? {} : { policy }),
    ...(subscriberGroup === undefined ? {} : { subscriberGroup }),
    ...(direction === undefined ? {} : { direction }),
  };
  const [settings, setSettings] = useState(defaults);
  return (
    <Wrapper className="viewStatusSubscribers col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <Header
          title="Subscriber QoE Metrics"
          subtitle={
            <>
              Right click on the{" "}
              <span className="hyperlink-text"> Subscriber ID</span> or{" "}
              <span className="hyperlink-text">IP address</span> to show its
              corresponding Subscriber Dashboard.
            </>
          }
          contextMenu={<ContextMenu />}
          backButton={!!returnView}
          returnUrl={returnView}
        />
      </div>
      <div className="title-border"></div>
      <div id="subscribersReportContainer">
        <div className="card attached">
          <FilteringControls
            subnet={subnet}
            policy={policy}
            subscriberGroup={subscriberGroup}
            direction={direction}
            settings={settings}
            setSettings={setSettings}
          />
        </div>
      </div>
      <Suspense fallback={<div className="card">Loading...</div>}>
        <Report {...settings} timePeriod={timePeriod} metric={metric} />
      </Suspense>
      <MetricsHelpModal />
    </Wrapper>
  );
};

export default Subscribers;
